module.exports = __webpack_public_path__ + "static/media/bookheart_medium_text.a054dbbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bookheart_medium_text.jpg
// module id = 1197
// module chunks = 0